export default "__VITE_ASSET__BVKZmi8h__"